<script setup lang="ts">
import { onMounted } from 'vue'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useAuthStore } from '@/stores/auth'
import LicenseCheckAlert from '@/components/LicenseCheckAlert.vue'

useHead({
  link: [{
    rel: 'stylesheet',
    href: '/fonts/index.css',
    crossorigin: '',
  }],
})

const { handleLogin } = useAuthStore()
const schoolSelector = useSchoolSelector()

onMounted(async () => await handleLogin())
</script>

<template>
  <NuxtLayout>
    <ClientOnly>
      <VueQueryDevtools button-position="bottom-left" />
      <VueAxePopup />
      <MainAudioPlayer />
    </ClientOnly>
    <LicenseCheckAlert />
    <SchoolSelectorDialog v-if="schoolSelector.showDialog" />
    <NuxtPage v-else />
  </NuxtLayout>
</template>

<style>
  /* stylelint-disable */
  #__nuxt {
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "header"
      "main"
      "footer";
    min-height: 100vh;
  }
  /* stylelint-enable */

  header {
    grid-area: header;
  }

  main {
    grid-area: main;
    min-height: 0;
    max-width: 100vw;
  }

  footer {
    grid-area: footer;
  }

  .va-btn {
    padding: .5rem !important;
    width: fit-content !important;
    height: fit-content !important;
  }
</style>
